import React from "react";

function Frotend() {
  return (
    <div className="skills__content">
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bxl-javascript"></i>
            <div>
              <h3 className="skills__name">JavaScript</h3>
              <span className="skills__level">(ES6)</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bxl-vuejs"></i>
            <div>
              <h3 className="skills__name">Vue.js</h3>
              <span className="skills__level">(2, 3, Vuex, Pinia, Router)</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bxl-react"></i>
            <div>
              <h3 className="skills__name-no-label">React.js</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bxl-angular"></i>
            <div>
              <h3 className="skills__name-no-label">Angular</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-briefcase"></i>
            <div>
              <h3 className="skills__name">Other tools</h3>
              <span className="skills__level">(Jira, Jenkins)</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bxl-react"></i>
            <div>
              <h3 className="skills__name-no-label">React Native</h3>
            </div>
          </div>
        </div>
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bxl-css3"></i>
            <div>
              <h3 className="skills__name">CSS3</h3>
              <span className="skills__level">(Flexbox, Grid, Sass, Less)</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bxl-bootstrap"></i>
            <div>
              <h3 className="skills__name">CSS Frameworks</h3>
              <span className="skills__level">(Tailwind, Bootstrap)</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bxl-git"></i>
            <div>
              <h3 className="skills__name-no-label">GIT & Github</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bxl-typescript"></i>
            <div>
              <h3 className="skills__name-no-label">Typescript</h3>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bx-test-tube"></i>
            <div>
              <h3 className="skills__name">Unit Testing</h3>
              <span className="skills__level">(Vitest, Vue Test Utils, Jest)</span>
            </div>
          </div>
          <div className="skills__data">
            <i className="bx bxl-apple"></i>
            <div>
              <h3 className="skills__name-no-label">Swift</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Frotend;
